import React, { useMemo } from "react";
import { Modal } from "antd";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { closeShortcuts, selectUi } from "../../redux/ui/ui.slice";
import "./KeyboardShortcutsModal.scss";

interface Shortcut {
    keys: string[];
    label: string;
}

const KeyboardShortcutsModal: React.FC = () => {
    const dispatch = useAppDispatch();
    const { shortcutsOpen } = useAppSelector(selectUi);

    const isMac = useMemo(
        () =>
            typeof navigator !== "undefined" &&
            /Mac|iPhone|iPad/.test(navigator.platform || ""),
        []
    );
    const mod = isMac ? "⌘" : "Ctrl";

    const shortcuts: Shortcut[] = useMemo(
        () => [
            { keys: [mod, "K"], label: "Open search" },
            { keys: ["?"], label: "Show this shortcuts help" },
            { keys: ["Esc"], label: "Close dialogs / search" },
            { keys: ["↑", "↓"], label: "Navigate search results" },
            { keys: ["↵"], label: "Open the highlighted result" },
        ],
        [mod]
    );

    return (
        <Modal
            open={shortcutsOpen}
            onCancel={() => dispatch(closeShortcuts())}
            footer={null}
            title="Keyboard shortcuts"
            centered
            width={460}
            className="ksm-modal"
        >
            <ul className="ksm-list">
                {shortcuts.map((s) => (
                    <li key={s.label} className="ksm-row">
                        <span className="ksm-label">{s.label}</span>
                        <span className="ksm-keys">
                            {s.keys.map((k, i) => (
                                <React.Fragment key={k}>
                                    {i > 0 && (
                                        <span className="ksm-plus">+</span>
                                    )}
                                    <kbd className="ksm-kbd">{k}</kbd>
                                </React.Fragment>
                            ))}
                        </span>
                    </li>
                ))}
            </ul>
        </Modal>
    );
};

export default KeyboardShortcutsModal;
